export const SERVICES = [
  {
    slug: "unfallgutachten-koeln",
    name: "Unfallgutachten",
    icon: "FileSearch",
    image: "real-gutachten-uebergabe",
    imagePosition: "center 35%",
    imageAlt: "Kfz-Sachverständiger Francesco Marcone übergibt ein Unfallgutachten an eine Kundin in Köln",
    title: "Unfallgutachten Köln – kostenlos bei Fremdschuld | Marcone",
    description:
      "Unfallgutachten in Köln – kostenlos bei unverschuldetem Unfall. TÜV-zertifizierter Gutachter, 24 h erreichbar, unabhängig. Jetzt Schaden melden oder anrufen.",
    h1: "Unfallgutachten in Köln – kostenlos bei unverschuldetem Unfall",
    subtitle: "Schnelle Schadenaufnahme vor Ort, gerichtsfestes Gutachten in 24–48 Stunden. Die Kosten trägt die gegnerische Versicherung.",
    teaser: "Nach einem unverschuldeten Unfall dokumentieren wir den Schaden gerichtsfest – die Kosten trägt die gegnerische Versicherung.",
    problem: {
      heading: "Unfall gehabt – und jetzt?",
      paragraphs: [
        "Ein Unfall kommt immer ungelegen: Das Auto ist beschädigt, der Alltag muss weitergehen und die Versicherung des Unfallgegners meldet sich vielleicht schon mit einem eigenen Gutachter oder einem schnellen Abfindungsangebot. Viele Geschädigte wissen nicht, welche Ansprüche ihnen zustehen – und verschenken dadurch bares Geld.",
        "Ohne unabhängiges Gutachten fehlt Ihnen die Grundlage, um Reparaturkosten, Wertminderung, Nutzungsausfall oder Mietwagen vollständig durchzusetzen. Ein Kostenvoranschlag der Werkstatt reicht dafür in der Regel nicht aus – er enthält weder die Wertminderung noch den Wiederbeschaffungswert.",
      ],
    },
    solution: {
      heading: "Unsere Lösung: Ihr unabhängiges Unfallgutachten",
      text: "Als TÜV-zertifizierter Kfz-Sachverständiger und Partner der FSP Schaden- und Wertgutachterdienst GmbH erstellen wir Ihr Unfallgutachten schnell, neutral und nachvollziehbar. Wir arbeiten werkstatt- und versicherungsunabhängig – allein in Ihrem Interesse.",
      bullets: [
        "Beweissicherung mit Fotodokumentation aller Schäden",
        "Kalkulation der Reparaturkosten nach Herstellervorgaben",
        "Ermittlung von Wertminderung, Wiederbeschaffungs- und Restwert",
        "Angaben zu Reparaturdauer und Nutzungsausfall",
      ],
    },
    steps: [
      { title: "Schaden melden", text: "Rufen Sie an, schreiben Sie per WhatsApp oder melden Sie den Schaden online – gern direkt mit Fotos." },
      { title: "Besichtigung vor Ort", text: "Wir kommen zu Ihnen nach Hause, an den Arbeitsplatz oder in die Werkstatt – in Köln meist innerhalb von 24 Stunden." },
      { title: "Gutachten erhalten", text: "Das fertige Gutachten bekommen Sie in der Regel innerhalb von 24 bis 48 Stunden per E-Mail oder persönlich." },
      { title: "Versicherung zahlt", text: "Mit dem Gutachten reguliert die gegnerische Versicherung Ihren Schaden – auf Wunsch über einen Anwalt Ihrer Wahl." },
    ],
    costs: {
      heading: "Was kostet das Unfallgutachten?",
      paragraphs: [
        "Bei einem unverschuldeten Unfall zahlt die Haftpflichtversicherung des Unfallverursachers die Kosten für das Gutachten (§ 249 BGB). Für Sie ist unser Gutachten damit in der Regel kostenlos – auch dann, wenn die Versicherung bereits einen eigenen Sachverständigen angekündigt hat.",
        "Bei Teilschuld werden die Gutachterkosten entsprechend der Haftungsquote erstattet. Wir besprechen das vorab offen mit Ihnen, damit es keine Überraschungen gibt.",
      ],
    },
    trust: [
      "TÜV-zertifizierter Kfz-Sachverständiger",
      "Partner der FSP Schaden- und Wertgutachterdienst GmbH",
      "Werkstatt- und versicherungsunabhängig",
      "Mo–Fr 24 Stunden erreichbar, Termine vor Ort im Großraum Köln",
    ],
    faq: [
      { q: "Muss ich den Gutachter der gegnerischen Versicherung akzeptieren?", a: "Nein. Als Geschädigter dürfen Sie einen Sachverständigen Ihrer Wahl beauftragen. Das gilt auch, wenn die Versicherung bereits einen eigenen Gutachter geschickt oder angekündigt hat." },
      { q: "Ab welcher Schadenhöhe lohnt sich ein Gutachten?", a: "Liegt der Schaden voraussichtlich über der sogenannten Bagatellgrenze von rund 750 bis 1.000 Euro, ist ein Gutachten sinnvoll und wird von der Versicherung bezahlt. Bei kleineren Schäden genügt oft ein Kostenvoranschlag – wir sagen Ihnen ehrlich, was in Ihrem Fall passt." },
      { q: "Wie schnell erhalte ich das Unfallgutachten?", a: "Nach der Besichtigung erhalten Sie das Gutachten in der Regel innerhalb von 24 bis 48 Stunden – oft sogar noch am selben Tag." },
      { q: "Was benötige ich für den Termin?", a: "Fahrzeugschein, Fahrzeugschlüssel, die Daten des Unfallgegners und – falls vorhanden – das Aktenzeichen der Polizei. Fotos von der Unfallstelle sind hilfreich, aber kein Muss." },
    ],
  },
  {
    slug: "haftpflichtschaden",
    name: "Haftpflichtschaden",
    icon: "ShieldAlert",
    image: "hero-haftpflicht",
    imageAlt: "Zwei Autos nach einem Auffahrunfall mit Warndreieck auf einer Straße in Köln",
    title: "Gutachten bei Haftpflichtschaden in Köln | Marcone",
    description:
      "Gutachten bei Haftpflichtschaden: Wir sichern Beweise, beziffern Reparaturkosten & Wertminderung und setzen Ihre Ansprüche durch. Köln, 24 h erreichbar.",
    h1: "Gutachten bei Haftpflichtschaden – Ihre Ansprüche vollständig sichern",
    subtitle: "Lückenlose Dokumentation für die Regulierung durch die gegnerische Kfz-Haftpflichtversicherung.",
    teaser: "Wir sichern Beweise, beziffern Ihren Schaden vollständig und schaffen die Grundlage für die Regulierung durch die gegnerische Versicherung.",
    problem: {
      heading: "Die Versicherung des Gegners prüft genau",
      paragraphs: [
        "Wenn ein anderer Ihren Schaden verursacht hat, muss dessen Kfz-Haftpflichtversicherung zahlen. Doch Versicherer haben ein wirtschaftliches Interesse daran, möglichst wenig zu regulieren. Kürzungen bei Stundensätzen, Ersatzteilaufschlägen oder der Wertminderung sind keine Seltenheit.",
        "Wer ohne eigenes Gutachten verhandelt, hat kaum Argumente. Schäden, die nicht dokumentiert sind, lassen sich später nur schwer nachweisen – vor allem, wenn das Fahrzeug bereits repariert ist.",
      ],
    },
    solution: {
      heading: "Wir dokumentieren Ihren Haftpflichtschaden lückenlos",
      text: "Unser Gutachten erfasst alle Positionen, die Ihnen nach einem Haftpflichtschaden zustehen – technisch fundiert und für Versicherung, Anwalt und Gericht nachvollziehbar.",
      bullets: [
        "Reparaturkosten inklusive Lohn, Material und Lackierung",
        "Merkantile Wertminderung",
        "Nutzungsausfall bzw. Mietwagendauer",
        "Wiederbeschaffungs- und Restwert bei Totalschaden",
      ],
    },
    steps: [
      { title: "Kontakt aufnehmen", text: "Schildern Sie uns kurz den Unfallhergang – telefonisch, per WhatsApp oder über das Formular." },
      { title: "Schaden aufnehmen", text: "Wir besichtigen das Fahrzeug, fotografieren alle Schäden und prüfen auch versteckte Folgeschäden." },
      { title: "Gutachten übergeben", text: "Sie erhalten das Gutachten – auf Wunsch senden wir es direkt an Ihren Anwalt oder die Versicherung." },
      { title: "Regulierung", text: "Die gegnerische Versicherung reguliert auf Basis des Gutachtens. Bei Rückfragen stehen wir Ihnen zur Seite." },
    ],
    costs: {
      heading: "Wer bezahlt das Gutachten beim Haftpflichtschaden?",
      paragraphs: [
        "Ist die Schuldfrage klar, trägt die Haftpflichtversicherung des Verursachers die Gutachterkosten vollständig. Sie müssen nicht in Vorleistung gehen – die Abrechnung erfolgt in der Regel direkt mit der Versicherung.",
        "Ist die Haftung strittig, sprechen wir vorab mit Ihnen über das weitere Vorgehen. Oft lohnt sich dann zusätzlich ein Verkehrsrechtsanwalt – auch diesen dürfen Sie frei wählen.",
      ],
    },
    trust: [
      "Gerichtsfeste Dokumentation nach anerkannten Standards",
      "Erfahrung im Schadenmanagement mit allen gängigen Versicherern",
      "Verständliche Erklärungen ohne Fachchinesisch",
      "Ein persönlicher Ansprechpartner von der Besichtigung bis zur Regulierung",
    ],
    faq: [
      { q: "Was ist der Unterschied zwischen Gutachten und Kostenvoranschlag?", a: "Ein Kostenvoranschlag nennt nur die voraussichtlichen Reparaturkosten. Ein Gutachten dokumentiert zusätzlich Schadenumfang, Wertminderung, Wiederbeschaffungswert und Nutzungsausfall – und dient als Beweismittel." },
      { q: "Kann ich fiktiv abrechnen?", a: "Ja. Sie können sich die im Gutachten ermittelten Netto-Reparaturkosten auszahlen lassen, ohne das Fahrzeug reparieren zu lassen. Die Mehrwertsteuer wird nur erstattet, wenn sie tatsächlich anfällt." },
      { q: "Was ist Wertminderung?", a: "Ein Unfallfahrzeug ist auch nach fachgerechter Reparatur auf dem Markt weniger wert. Diese merkantile Wertminderung ermitteln wir im Gutachten – sie steht Ihnen zusätzlich zu den Reparaturkosten zu." },
      { q: "Wann sollte ich den Gutachter beauftragen?", a: "Je früher, desto besser – idealerweise vor der Reparatur. Nur so lassen sich alle Schäden eindeutig dokumentieren." },
    ],
  },
  {
    slug: "kaskoschaden-gutachter",
    name: "Kaskoschaden",
    icon: "CloudHail",
    image: "hero-kasko",
    imageAlt: "Gutachter prüft Hagelschaden und Steinschlag an einem weißen Auto in Köln",
    title: "Kaskoschaden: unabhängiger Gutachter in Köln | Marcone",
    description:
      "Kaskoschaden durch Hagel, Wild, Diebstahl oder Eigenverschulden? Unabhängiges Gutachten als Zweitmeinung – damit Ihre Versicherung fair reguliert. Köln.",
    h1: "Kaskoschaden: unabhängiger Gutachter für Ihre Zweitmeinung",
    subtitle: "Hagel, Wild, Glas, Vandalismus oder selbst verschuldet – wir prüfen, ob Ihre Versicherung fair reguliert.",
    teaser: "Hagel, Wild, Glas oder selbst verschuldeter Unfall: Mit unserem unabhängigen Gutachten prüfen Sie das Angebot Ihrer Kaskoversicherung.",
    problem: {
      heading: "Wenn die eigene Versicherung den Wert bestimmt",
      paragraphs: [
        "Bei einem Kaskoschaden – etwa durch Hagel, Wildunfall, Sturm, Vandalismus, Diebstahl oder einen selbst verschuldeten Unfall – reguliert Ihre eigene Versicherung. Meist schickt sie einen eigenen Gutachter oder setzt auf eine Partnerwerkstatt.",
        "Das Ergebnis fällt nicht immer zu Ihren Gunsten aus: Wiederbeschaffungswerte werden niedrig angesetzt, Reparaturwege vorgegeben oder Schäden übersehen. Ohne fachliche Gegenprüfung lässt sich das kaum beurteilen.",
      ],
    },
    solution: {
      heading: "Unabhängige Zweitmeinung für Ihren Kaskoschaden",
      text: "Wir prüfen das Gutachten oder Angebot Ihrer Versicherung und erstellen auf Wunsch ein eigenes Gutachten. So erkennen Sie, ob die Regulierung angemessen ist – und haben belastbare Argumente für die Nachverhandlung.",
      bullets: [
        "Prüfung des Versicherungsgutachtens auf Plausibilität",
        "Eigene Ermittlung von Reparaturkosten und Wiederbeschaffungswert",
        "Dokumentation von Hagel-, Glas-, Wild- und Vandalismusschäden",
        "Unterstützung im Sachverständigenverfahren nach den Versicherungsbedingungen",
      ],
    },
    steps: [
      { title: "Unterlagen senden", text: "Schicken Sie uns Fotos und – falls vorhanden – das Gutachten oder Angebot Ihrer Versicherung." },
      { title: "Ersteinschätzung", text: "Wir sagen Ihnen ehrlich, ob sich eine Zweitmeinung für Sie lohnt." },
      { title: "Begutachtung", text: "Wir besichtigen das Fahrzeug und erstellen unser unabhängiges Gutachten." },
      { title: "Nachverhandlung", text: "Mit dem Gutachten verhandeln Sie oder Ihr Anwalt gegenüber der Versicherung nach." },
    ],
    costs: {
      heading: "Was kostet ein Gutachten beim Kaskoschaden?",
      paragraphs: [
        "Anders als beim unverschuldeten Unfall übernimmt bei einem Kaskoschaden in der Regel niemand automatisch die Gutachterkosten. Deshalb erhalten Sie von uns vorab eine kostenlose Ersteinschätzung und ein transparentes Angebot.",
        "Ob sich ein eigenes Gutachten rechnet, hängt von der Differenz zum Angebot der Versicherung ab. Wir beraten Sie offen – auch dann, wenn sich ein Gutachten für Sie nicht lohnt.",
      ],
    },
    trust: [
      "Unabhängig von Ihrer Versicherung und deren Partnerwerkstätten",
      "Kostenlose Ersteinschätzung anhand Ihrer Fotos",
      "Transparentes Angebot vor Auftragserteilung",
      "TÜV-zertifizierte Fachkompetenz",
    ],
    faq: [
      { q: "Darf ich bei einem Kaskoschaden einen eigenen Gutachter beauftragen?", a: "Ja. Sie dürfen jederzeit einen eigenen Sachverständigen hinzuziehen – etwa um das Gutachten Ihrer Versicherung überprüfen zu lassen." },
      { q: "Was ist das Sachverständigenverfahren?", a: "Viele Kaskoversicherungen sehen in ihren Bedingungen (AKB) ein Sachverständigenverfahren vor: Können Sie sich mit der Versicherung nicht über die Schadenhöhe einigen, benennt jede Seite einen Gutachter. Wir vertreten dabei Ihre Seite." },
      { q: "Muss ich in die Partnerwerkstatt der Versicherung?", a: "Das hängt von Ihrem Vertrag ab. Bei Tarifen mit Werkstattbindung gelten besondere Regeln – wir prüfen gern, was in Ihrem Fall gilt." },
      { q: "Lohnt sich ein Gutachten bei Hagelschaden?", a: "Gerade bei Hagelschäden werden Dellen häufig unterschätzt. Eine unabhängige Dokumentation lohnt sich vor allem bei hochwertigen Fahrzeugen oder vielen Dellen." },
    ],
  },
  {
    slug: "leasingruecknahme-gutachten",
    name: "Leasingrücknahme",
    icon: "KeyRound",
    image: "hero-leasing",
    imageAlt: "Grauer SUV bei der Leasingrückgabe mit Prüfprotokoll auf der Motorhaube",
    title: "Rücknahmegutachten für Leasingfahrzeuge Köln | Marcone",
    description:
      "Rücknahmegutachten für Leasingfahrzeuge in Köln: Wir dokumentieren den Zustand neutral und schützen Sie vor überhöhten Nachforderungen. Jetzt Termin anfragen.",
    h1: "Rücknahmegutachten für Leasingfahrzeuge – fair zurückgeben",
    subtitle: "Neutrale Zustandsdokumentation vor der Rückgabe – damit Sie nur zahlen, was wirklich fällig ist.",
    teaser: "Neutrale Zustandsdokumentation vor der Rückgabe Ihres Leasing- oder Finanzierungsfahrzeugs – damit Sie nur zahlen, was wirklich fällig ist.",
    problem: {
      heading: "Leasingrückgabe: teure Überraschungen vermeiden",
      paragraphs: [
        "Am Ende der Laufzeit wird Ihr Leasingfahrzeug vom Leasinggeber oder Autohaus begutachtet. Kratzer, Steinschläge, Dellen oder abgefahrene Reifen werden dabei schnell als „übermäßige Abnutzung“ gewertet – und landen als Nachforderung auf Ihrer Rechnung.",
        "Was normale Gebrauchsspuren sind und was nicht, ist oft Auslegungssache. Ohne eigene Dokumentation stehen Sie bei Streitigkeiten mit leeren Händen da.",
      ],
    },
    solution: {
      heading: "Unser Rücknahmegutachten schafft Klarheit",
      text: "Wir dokumentieren den Zustand Ihres Fahrzeugs neutral und nachvollziehbar – idealerweise einige Wochen vor der Rückgabe. So wissen Sie, welche Schäden als normale Abnutzung gelten und wo sich eine Reparatur vorab lohnt.",
      bullets: [
        "Zustandsbericht mit detaillierter Fotodokumentation",
        "Bewertung nach gängigen Rückgabe-Richtlinien",
        "Kalkulation eventuell anfallender Reparaturkosten",
        "Unterstützung bei überhöhten Nachforderungen",
      ],
    },
    steps: [
      { title: "Termin vereinbaren", text: "Am besten vier bis sechs Wochen vor dem Rückgabetermin." },
      { title: "Zustand prüfen", text: "Wir begutachten Karosserie, Lack, Felgen, Reifen, Scheiben und Innenraum." },
      { title: "Bericht erhalten", text: "Sie bekommen einen klaren Zustandsbericht mit Fotos und Kostenschätzung." },
      { title: "Sicher zurückgeben", text: "Sie entscheiden, ob Sie vorab reparieren – und haben bei der Rückgabe eine eigene Dokumentation." },
    ],
    costs: {
      heading: "Was kostet ein Rücknahmegutachten?",
      paragraphs: [
        "Die Kosten richten sich nach Fahrzeugtyp und Umfang. Sie erhalten vorab ein verbindliches Festpreisangebot – ohne versteckte Kosten.",
        "Im Vergleich zu typischen Nachforderungen bei der Leasingrückgabe ist ein eigenes Gutachten oft eine lohnende Investition.",
      ],
    },
    trust: [
      "Neutral – weder dem Leasinggeber noch dem Autohaus verpflichtet",
      "Nachvollziehbare Fotodokumentation",
      "Erfahrung mit Leasing- und Finanzierungsrückläufern",
      "Auch für Firmen- und Flottenfahrzeuge",
    ],
    faq: [
      { q: "Wann sollte ich das Rücknahmegutachten erstellen lassen?", a: "Idealerweise vier bis sechs Wochen vor der Rückgabe. Dann bleibt genug Zeit, kleinere Schäden günstig beheben zu lassen." },
      { q: "Was gilt als normale Abnutzung?", a: "Leichte Gebrauchsspuren, die dem Alter und der Laufleistung entsprechen, sind in der Regel normal. Dellen, tiefe Kratzer oder beschädigte Felgen gehen meist darüber hinaus. Wir bewerten das im Einzelfall." },
      { q: "Hilft das Gutachten bei Streit mit dem Leasinggeber?", a: "Ja. Unser Gutachten dient als neutrale Dokumentation und kann Ihnen bei Verhandlungen über Nachforderungen helfen." },
      { q: "Prüfen Sie auch Fahrzeuge aus einer Finanzierung?", a: "Ja. Auch bei der Rückgabe finanzierter Fahrzeuge mit Schlussrate oder Rückkaufvereinbarung erstellen wir Zustands- und Rücknahmegutachten." },
    ],
  },
  {
    slug: "wertgutachten-koeln",
    name: "Wertgutachten",
    icon: "BadgeEuro",
    image: "hero-wertgutachten",
    imageAlt: "Dunkelblaue Limousine in einer hellen Halle neben einem Tablet mit Wertanalyse",
    title: "Fahrzeugbewertung & Wertgutachten Köln | Marcone",
    description:
      "Fahrzeugbewertung & Wertgutachten in Köln für Kauf, Verkauf, Erbschaft, Scheidung oder Versicherung. TÜV-zertifiziert, neutral und schnell. Jetzt anfragen.",
    h1: "Fahrzeugbewertung & Wertgutachten in Köln",
    subtitle: "Ein belastbarer Fahrzeugwert für Kauf, Verkauf, Erbschaft, Scheidung, Versicherung oder Steuer.",
    teaser: "Zuverlässiger Fahrzeugwert für Kauf, Verkauf, Erbschaft, Scheidung, Versicherung oder Steuer – neutral ermittelt.",
    problem: {
      heading: "Was ist Ihr Fahrzeug wirklich wert?",
      paragraphs: [
        "Online-Bewertungen liefern oft nur grobe Richtwerte. Ausstattung, Pflegezustand, Historie und regionale Marktlage bleiben dabei weitgehend unberücksichtigt.",
        "Wenn es um viel Geld geht – beim privaten Verkauf, bei Erbschaft, Scheidung, Firmenübergabe oder Versicherungsfragen – brauchen Sie einen belastbaren Wert, den auch Dritte akzeptieren.",
      ],
    },
    solution: {
      heading: "Unser Wertgutachten: neutral und nachvollziehbar",
      text: "Wir ermitteln den Wert Ihres Fahrzeugs auf Basis einer gründlichen Besichtigung und aktueller Marktdaten. Das Ergebnis ist ein schriftliches Gutachten, das Sie gegenüber Käufern, Behörden, Gerichten oder Versicherungen verwenden können.",
      bullets: [
        "Händlereinkaufs-, Händlerverkaufs- und Wiederbeschaffungswert",
        "Berücksichtigung von Ausstattung, Zustand und Historie",
        "Für Pkw, Motorräder, Wohnmobile und Nutzfahrzeuge",
        "Auch für Firmenwagen, Erbschaften und Scheidungen",
      ],
    },
    steps: [
      { title: "Anfrage stellen", text: "Nennen Sie uns Fahrzeug und Anlass – wir senden Ihnen ein Angebot." },
      { title: "Besichtigung", text: "Wir prüfen das Fahrzeug bei Ihnen vor Ort oder in unserem Büro in Köln-Nippes." },
      { title: "Bewertung", text: "Wir werten Zustand, Ausstattung und aktuelle Marktdaten aus." },
      { title: "Gutachten", text: "Sie erhalten Ihr schriftliches Wertgutachten – meist innerhalb weniger Tage." },
    ],
    costs: {
      heading: "Was kostet ein Wertgutachten?",
      paragraphs: [
        "Der Preis hängt vom Fahrzeug und vom gewünschten Umfang ab – vom Kurzgutachten bis zum ausführlichen Gutachten. Sie erhalten vorab ein transparentes Festpreisangebot.",
        "Wird der Wert nach einem unverschuldeten Totalschaden ermittelt, übernimmt in der Regel die gegnerische Versicherung die Kosten.",
      ],
    },
    trust: [
      "TÜV-zertifizierte Bewertungskompetenz",
      "Neutral – kein eigenes Interesse am Kauf oder Verkauf",
      "Gutachten für private und gewerbliche Auftraggeber",
      "Schnelle Termine im Großraum Köln",
    ],
    faq: [
      { q: "Wofür brauche ich ein Wertgutachten?", a: "Typische Anlässe sind Kauf und Verkauf, Erbschaft, Scheidung, Schenkung, die Entnahme aus dem Betriebsvermögen oder die Absicherung bei der Versicherung." },
      { q: "Was ist der Unterschied zwischen Händlereinkaufs- und Wiederbeschaffungswert?", a: "Der Händlereinkaufswert ist der Preis, den ein Händler zahlen würde. Der Wiederbeschaffungswert ist der Betrag, den Sie für ein vergleichbares Fahrzeug bei einem seriösen Händler bezahlen müssten." },
      { q: "Wie lange ist ein Wertgutachten gültig?", a: "Ein Wertgutachten bildet den Wert zum Stichtag ab. Bei stark schwankenden Märkten empfehlen wir, es nach etwa einem Jahr zu aktualisieren." },
      { q: "Bewerten Sie auch Motorräder und Wohnmobile?", a: "Ja. Neben Pkw bewerten wir auch Motorräder, Wohnmobile und leichte Nutzfahrzeuge." },
    ],
  },
  {
    slug: "oldtimergutachten-koeln",
    name: "Oldtimergutachten",
    icon: "Gem",
    image: "hero-oldtimer",
    imageAlt: "Gelber Oldtimer auf Kopfsteinpflaster in der Kölner Altstadt mit Dom im Hintergrund",
    title: "Oldtimergutachten in Köln – Wert & Zustand | Marcone",
    description:
      "Oldtimergutachten in Köln: Zustandsnote, Markt- und Wiederbeschaffungswert für Versicherung, Kauf oder Verkauf Ihres Klassikers. Sachkundig & unabhängig.",
    h1: "Oldtimergutachten in Köln – Wert und Zustand Ihres Klassikers",
    subtitle: "Zustandsnote, Marktwert und Wiederbeschaffungswert für Oldtimer und Youngtimer.",
    teaser: "Zustandsnote, Marktwert und Wiederbeschaffungswert für Ihren Oldtimer oder Youngtimer – für Versicherung, Kauf oder Verkauf.",
    problem: {
      heading: "Ein Klassiker verdient eine fundierte Bewertung",
      paragraphs: [
        "Der Wert eines Oldtimers hängt von vielen Details ab: Originalität, Zustand, Qualität der Restaurierung, Historie und Nachfrage. Pauschale Listenpreise werden diesen Fahrzeugen nicht gerecht.",
        "Ohne aktuelles Wertgutachten ist Ihr Klassiker oft unterversichert. Im Schadenfall erhalten Sie dann nur einen Bruchteil dessen, was das Fahrzeug tatsächlich wert ist.",
      ],
    },
    solution: {
      heading: "Unser Oldtimergutachten: sachkundig und detailliert",
      text: "Wir begutachten Ihren Oldtimer oder Youngtimer gründlich und dokumentieren Zustand und Originalität. Daraus ermitteln wir Markt- und Wiederbeschaffungswert – als Grundlage für eine passende Versicherung oder einen fairen Kauf bzw. Verkauf.",
      bullets: [
        "Zustandsbewertung nach gängigem Notensystem (1–5)",
        "Markt- und Wiederbeschaffungswert",
        "Ausführliche Fotodokumentation",
        "Für Versicherung, Kauf, Verkauf und Restaurierungsplanung",
      ],
    },
    steps: [
      { title: "Anfrage", text: "Teilen Sie uns Marke, Modell, Baujahr und Anlass mit." },
      { title: "Termin", text: "Wir begutachten Ihren Klassiker bei Ihnen, in der Garage oder in der Werkstatt." },
      { title: "Bewertung", text: "Karosserie, Technik, Innenraum und Originalität werden genau geprüft." },
      { title: "Gutachten", text: "Sie erhalten ein ausführliches Gutachten mit Zustandsnote und Wertangabe." },
    ],
    costs: {
      heading: "Was kostet ein Oldtimergutachten?",
      paragraphs: [
        "Der Aufwand richtet sich nach Fahrzeug und Gutachtenumfang. Wir erstellen Ihnen vorab ein verbindliches Festpreisangebot.",
        "Viele Oldtimerversicherer verlangen ein aktuelles Wertgutachten – es zahlt sich spätestens im Schadenfall aus.",
      ],
    },
    trust: [
      "Erfahrung mit klassischen Fahrzeugen",
      "Detaillierte, nachvollziehbare Dokumentation",
      "Unabhängig von Händlern und Versicherern",
      "Begutachtung vor Ort in Köln und Umgebung",
    ],
    faq: [
      { q: "Ab wann gilt ein Fahrzeug als Oldtimer?", a: "Umgangssprachlich ab einem Alter von 30 Jahren. Fahrzeuge zwischen etwa 20 und 30 Jahren werden oft als Youngtimer bezeichnet – auch für sie erstellen wir Wertgutachten." },
      { q: "Was bedeutet die Zustandsnote?", a: "Die Zustandsnote reicht von 1 (makellos) bis 5 (restaurierungsbedürftig) und beschreibt den Gesamtzustand des Fahrzeugs. Sie ist eine wichtige Grundlage für den Wert." },
      { q: "Wie oft sollte ein Oldtimergutachten erneuert werden?", a: "Viele Versicherer empfehlen eine Aktualisierung alle zwei bis drei Jahre oder nach einer Restaurierung." },
      { q: "Begutachten Sie auch Youngtimer und Motorräder?", a: "Ja. Wir bewerten Youngtimer, klassische Motorräder und Sammlerfahrzeuge." },
    ],
  },
  {
    slug: "gebrauchtwagen-check",
    name: "Gebrauchtwagen-Check",
    icon: "ClipboardCheck",
    image: "hero-gebrauchtwagen",
    imageAlt: "Gebrauchtwagen auf der Hebebühne bei der Prüfung des Unterbodens",
    title: "Gebrauchtwagen-Check vor dem Kauf in Köln | Marcone",
    description:
      "Gebrauchtwagencheck vor dem Kauf: Wir prüfen Unfallschäden, Lack, Technik und Preis – bevor Sie unterschreiben. Unabhängig, schnell, in Köln & Umgebung.",
    h1: "Gebrauchtwagen-Check vor dem Kauf – sicher entscheiden",
    subtitle: "Unabhängige Prüfung auf Vorschäden, Lack, Technik und einen fairen Preis.",
    teaser: "Unabhängige Prüfung vor dem Kauf: Unfallschäden, Lack, Technik und Preis – bevor Sie unterschreiben.",
    problem: {
      heading: "Was verschweigt der Verkäufer?",
      paragraphs: [
        "Ein Gebrauchtwagen sieht auf Fotos oft besser aus als in Wirklichkeit. Reparierte Unfallschäden, nachlackierte Teile oder technische Mängel sind für Laien kaum zu erkennen.",
        "Wer ungeprüft kauft, riskiert hohe Folgekosten – oder zahlt deutlich zu viel. Beim Privatkauf ist die Gewährleistung zudem meist ausgeschlossen.",
      ],
    },
    solution: {
      heading: "Unser Gebrauchtwagen-Check gibt Ihnen Sicherheit",
      text: "Wir prüfen das Wunschfahrzeug unabhängig und gründlich – beim Händler, beim Privatverkäufer oder bei Ihnen. Anschließend erhalten Sie eine klare Einschätzung zu Zustand, Mängeln und einem fairen Preis.",
      bullets: [
        "Lackschichtdickenmessung zur Erkennung von Vorschäden",
        "Sichtprüfung von Karosserie, Unterboden, Reifen und Bremsen",
        "Prüfung von Fahrzeughistorie und Unterlagen",
        "Einschätzung eines fairen Kaufpreises",
      ],
    },
    steps: [
      { title: "Fahrzeug nennen", text: "Schicken Sie uns den Link zur Anzeige oder die Fahrzeugdaten." },
      { title: "Termin vor Ort", text: "Wir prüfen das Fahrzeug direkt beim Verkäufer – in Köln und Umgebung." },
      { title: "Ergebnis", text: "Sie erhalten eine verständliche Zusammenfassung mit Fotos." },
      { title: "Entscheidung", text: "Sie verhandeln den Preis – oder lassen die Finger davon." },
    ],
    costs: {
      heading: "Was kostet der Gebrauchtwagen-Check?",
      paragraphs: [
        "Sie erhalten vorab ein transparentes Festpreisangebot – abhängig von Fahrzeug und Prüfumfang.",
        "Im Vergleich zu den Kosten eines versteckten Unfallschadens ist der Check eine kleine Investition mit großer Wirkung.",
      ],
    },
    trust: [
      "Unabhängig – wir verdienen nicht am Verkauf",
      "Messtechnik für Lack und Karosserie",
      "Verständliche Ergebnisse ohne Fachchinesisch",
      "Schnelle Termine, auch kurzfristig",
    ],
    faq: [
      { q: "Wie lange dauert der Gebrauchtwagen-Check?", a: "Je nach Fahrzeug etwa 45 bis 90 Minuten vor Ort." },
      { q: "Kommen Sie auch zum Händler?", a: "Ja. Wir prüfen das Fahrzeug beim Händler, beim Privatverkäufer oder an einem vereinbarten Ort in Köln und Umgebung." },
      { q: "Erkennen Sie reparierte Unfallschäden?", a: "Mit Lackschichtdickenmessung und geschultem Blick erkennen wir nachlackierte oder gespachtelte Bereiche sowie typische Spuren von Unfallreparaturen." },
      { q: "Ersetzt der Check eine Hauptuntersuchung?", a: "Nein. Der Gebrauchtwagen-Check ist eine Kaufberatung und ersetzt keine Hauptuntersuchung nach § 29 StVZO." },
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
